import classes from "./Projects.module.css";
import { ProjectCard, TProjectCard } from "src/components/ProjectCard";

const projectData: TProjectCard[] = [
  {
    title: "GraphQL Pagination Framework",
    description:
      "Open-source framework layer that automatically handles pagination, filtering, and sorting for GraphQL APIs. Built on top of TypeORM, it reduces boilerplate code by 80% and standardizes API patterns across microservices.",
    tech: ["TypeScript", "GraphQL", "TypeGraphQL", "TypeORM"],
    links: [
      {
        title: "App Store",
        href: "https://apps.apple.com/us/app/club-management-app/id1537462730",
      },
    ],
  },
  {
    title: "Document Search with Vector Embeddings",
    description:
      "Built a complete pipeline for digitizing scanned documents and enabling semantic search. Converts PDFs/images to searchable text using OCR, generates vector embeddings, and provides a chat interface for natural language queries with source citations.",
    tech: ["Python", "Tesseract OCR", "OpenAI", "VectorDB", "MongoDB"],
    links: [],
  },
];

const Projects = () => {
  return (
    <div className={classes["projects-container"]}>
      {projectData.map((project) => (
        <ProjectCard key={project.title} {...project} />
      ))}
    </div>
  );
};

export default Projects;
